import { render, staticRenderFns } from "./TargetGoalPanel.vue?vue&type=template&id=9deddb02&scoped=true"
import script from "./TargetGoalPanel.vue?vue&type=script&lang=js"
export * from "./TargetGoalPanel.vue?vue&type=script&lang=js"
import style0 from "./TargetGoalPanel.vue?vue&type=style&index=0&id=9deddb02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9deddb02",
  null
  
)

export default component.exports